import { useHelpText } from '../../../../api/texts/hooks'
import { useHelperModalProps } from '../types'

const useHelperModal = ({ textKey, ...rest }: useHelperModalProps) => {
    const { data: text } = useHelpText(textKey)
    return {
        ...rest,
        text,
    }
}
export default useHelperModal
